module.exports = __webpack_public_path__ + "img/图1-8尺寸标注的组成要素.5a8f1ab9.jpg";